import RightOfWithdrawalComponent from './RightOfWithdrawalComponent'

export default RightOfWithdrawalComponent
